import type { AdStudioTemplateFoldersQuery } from "src/graphql";
import { folderAndSubfolderIds } from "src/pages/projects/library/folder-paths";

export function templatesInFolders<Template extends { id: string }>(
  templates: readonly Template[],
  folderIds: readonly string[],
  data: AdStudioTemplateFoldersQuery,
): Template[] {
  const descendants = new Set(
    folderIds.flatMap((id) => [
      ...folderAndSubfolderIds(data.ampFileFolders, id),
    ]),
  );
  const memberIds = new Set(
    data.templateFiles.flatMap((file) =>
      file.settings_entity_id &&
      file.folder_id &&
      descendants.has(file.folder_id)
        ? [file.settings_entity_id]
        : [],
    ),
  );
  return templates.filter((template) => memberIds.has(template.id));
}
